import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { setPipelineReleaseViewRouteParameters } from '../ngrx/store/routing/routing.actions';

@Injectable({ providedIn: 'root' })
export class PipelineReleaseViewResolver implements Resolve<void> {
  private readonly store$ = inject(Store);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.store$.dispatch(
      setPipelineReleaseViewRouteParameters({
        deliveryGuid: route.params['deliveryGuid'],
        pipelineId: route.params['pipelineId'],
        microdeliveryId: route.queryParams['mdId'] || route.queryParams['microdeliveryId'],
        pipelineRunId: this.tryParseNumber(route.queryParams['pipelineRunId']),
        pipelineRunKey: route.queryParams['pipelineRunKey'],
        expectedCentralPolicyKeys:
          route.queryParams['expectedPolicies']?.trim().length > 0 ? route.queryParams['expectedPolicies'].split(',') : null,
      }),
    );
  }

  private tryParseNumber(value: string): number {
    if (!value) {
      return null;
    }
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  }
}
